import React, { useState } from 'react';
import { Info } from 'lucide-react';

/**
 * InfoTooltip Component
 * Light orange tooltip with 2-3 line explanations
 * WCAG compliant with keyboard navigation
 */
const InfoTooltip = ({ content, position = 'top' }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2'
  };

  return (
    <div className="relative inline-block">
      <button
        type="button"
        className="text-gray-400 hover:text-[#DF8C4D] transition-colors focus:outline-none focus:ring-2 focus:ring-[#DF8C4D] focus:ring-offset-1 rounded-full p-1"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            setIsVisible(false);
          }
        }}
        aria-label="More information"
        aria-expanded={isVisible}
      >
        <Info size={16} />
      </button>

      {/* Tooltip */}
      {isVisible && (
        <div
          className={`absolute z-50 w-64 p-3 bg-[#FFF5EC] border border-[#DF8C4D] border-opacity-24 rounded-lg shadow-lg text-xs text-[#6B4B2C] leading-relaxed ${positionClasses[position]}`}
          role="tooltip"
        >
          {/* Arrow */}
          <div
            className={`absolute w-2 h-2 bg-[#FFF5EC] border-[#DF8C4D] border-opacity-24 transform rotate-45 ${
              position === 'top' ? 'bottom-[-4px] left-1/2 -translate-x-1/2 border-r border-b' :
              position === 'bottom' ? 'top-[-4px] left-1/2 -translate-x-1/2 border-l border-t' :
              position === 'left' ? 'right-[-4px] top-1/2 -translate-y-1/2 border-t border-r' :
              'left-[-4px] top-1/2 -translate-y-1/2 border-b border-l'
            }`}
          />
          
          {/* Content */}
          <div className="relative z-10">
            {content}
          </div>
        </div>
      )}
    </div>
  );
};

export default InfoTooltip;
